import styles from './Cta.module.scss';

export const Theme = {
    primary: {
        stylingClass: styles.Primary,
    },
    secondary: {
        stylingClass: styles.Secondary,
    },
    tertiary: {
        stylingClass: styles.Tertiary,
    },
    inverted: {
        stylingClass: styles.Inverted,
    },
};
